import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=984fc67a&"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=984fc67a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports